import styled from "styled-components"

import { maxWidth, when } from "utils"

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 1.6rem;
  margin-top: 3.5rem;
`

export const TableRow = styled.tr`
  width: 100%;
  border-bottom: 0.1rem solid #222;

  ${when("firstRow")`
    width: 50%;
  `}
`

export const TableHeader = styled.thead``

export const TableHeading = styled.th`
  text-align: left;
  font-weight: 500;
  padding-bottom: 0.2rem;

  ${maxWidth.tablet`
    display: ${(props) => props.hideOnMobile && "none"};
  `}
`

export const TableBody = styled.tbody``

export const TableCell = styled.td`
  padding: 1.5rem 0;

  ${when("firstRow")`
    width: 50%;
    padding-right: 2rem;
  `}

  ${maxWidth.tablet`
    display: ${(props) => props.hideOnMobile && "none"};
  `}
`

export const TableBodyData = styled.p`
  display: none;
  font-weight: 500;
  font-size: 1.4rem;

  ${maxWidth.tablet`
    display: block;
  `}
`
export const PriceIncluded = styled.span`
  text-decoration: line-through;
`

export const BoldText = styled.span`
  font-weight: 500;
  margin-top: 0.3rem;
`

export const ClassTitle = styled.h3``

export const Spacer = styled.span`
  margin-right: 1rem;
`

export const TableContainer = styled.div`
  padding-left: 4.8rem;
  padding-right: 4.8rem;

  ${maxWidth.tablet`
    padding-left: 2rem;
    padding-right: 2rem;
  `}

  ${maxWidth.mobile`
    padding-left: 0;
    padding-right: 0;
    max-width: 98.4rem;
    margin: 0 auto;
  `}
`
